/* Metcos — Floating Store Reviews Tab */
(function () {
  'use strict';

  var SCROLL_LOCK = 'mdj-rt-scroll-lock';

  var AVATAR_COLORS = [
    '#b08d57', '#8a6d3b', '#a8743f', '#7d6a4f',
    '#9c7c4a', '#6f5b3e', '#c09a63', '#8f7350'
  ];

  var G_SVG =
    '<svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">' +
    '<path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-2.7-.4-4H24v7.3h12.1c-.2 2-1.6 5-4.5 7l-.1.3 6.5 5 .5.1c4.2-3.8 6.6-9.5 6.6-15.7z"/>' +
    '<path fill="#34A853" d="M24 46c5.9 0 10.9-2 14.5-5.3l-6.9-5.4c-1.8 1.3-4.3 2.2-7.6 2.2-5.8 0-10.7-3.8-12.5-9.1l-.3.1-6.8 5.2-.1.3C7.9 41 15.4 46 24 46z"/>' +
    '<path fill="#FBBC05" d="M11.5 28.4c-.5-1.4-.7-2.9-.7-4.4s.3-3 .7-4.4v-.3l-6.9-5.4-.2.1A22 22 0 0 0 2 24c0 3.5.9 6.9 2.4 9.9l7.1-5.5z"/>' +
    '<path fill="#EB4335" d="M24 10.5c4.1 0 6.9 1.8 8.5 3.2l6.2-6C34.9 4.2 29.9 2 24 2 15.4 2 7.9 7 4.4 14.1l7.1 5.5c1.8-5.3 6.7-9.1 12.5-9.1z"/>' +
    '</svg>';

  function decorate(root) {
    var items = root.querySelectorAll('.jdgm-carousel-item');
    Array.prototype.forEach.call(items, function (item, idx) {
      if (item.dataset.mdjDone === '1') return;
      item.dataset.mdjDone = '1';

      var nameEl = item.querySelector('.jdgm-carousel-item__reviewer-name');
      var name = nameEl ? (nameEl.textContent || '').trim() : '';
      if (!name) name = 'Google customer';

      var bodyEl = item.querySelector('.jdgm-carousel-item__review-body');
      var bodyText = bodyEl ? (bodyEl.textContent || '').trim() : '';

      // Short one-liners get pull-quote treatment
      if (bodyText && bodyText.length <= 45) item.classList.add('mdj-short');

      // Rating-only reviews get a readable line instead of blank space
      if (!bodyText) {
        var ratingEl = item.querySelector('.jdgm-carousel-item__review-rating');
        var label = ratingEl ? ratingEl.getAttribute('aria-label') || '' : '';
        var n = (label.match(/\d/) || ['5'])[0];
        var p = document.createElement('p');
        p.className = 'mdj-rev__rated';
        p.textContent = 'Rated ' + n + ' out of 5';
        var content = item.querySelector('.jdgm-carousel-item__review-content');
        if (content) content.appendChild(p);
      }

      // Google-style reviewer header with monogram avatar
      var head = document.createElement('div');
      head.className = 'mdj-rev__head';

      var avatar = document.createElement('span');
      avatar.className = 'mdj-rev__avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent = name.charAt(0).toUpperCase();
      avatar.style.background = AVATAR_COLORS[(name.charCodeAt(0) + idx) % AVATAR_COLORS.length];

      var meta = document.createElement('span');
      meta.className = 'mdj-rev__meta';

      var nameSpan = document.createElement('span');
      nameSpan.className = 'mdj-rev__name';
      nameSpan.textContent = name;

      var src = document.createElement('span');
      src.className = 'mdj-rev__src';
      src.innerHTML = G_SVG;
      var srcLabel = document.createElement('span');
      srcLabel.textContent = 'Google review';
      src.appendChild(srcLabel);

      meta.appendChild(nameSpan);
      meta.appendChild(src);
      head.appendChild(avatar);
      head.appendChild(meta);

      item.insertBefore(head, item.firstChild);
    });
    return items.length;
  }

  function init(root) {
    if (root.dataset.mdjRtReady === '1') return;
    root.dataset.mdjRtReady = '1';

    var tab = root.querySelector('[data-mdj-open]');
    var panel = root.querySelector('.mdj-rt__panel');
    var list = root.querySelector('[data-mdj-list]');
    var fallback = root.querySelector('[data-mdj-fallback]');
    if (!tab || !panel) return;

    var lastY = 0;

    if (list) {
      var found = decorate(list);
      if (!found && fallback) {
        // give Judge.me a moment, then admit defeat gracefully
        var tries = 0;
        var t = setInterval(function () {
          tries++;
          if (decorate(list) > 0) { fallback.hidden = true; clearInterval(t); }
          else if (tries > 12) { fallback.hidden = false; clearInterval(t); }
        }, 500);
      }
    }

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function lock() {
      lastY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add(SCROLL_LOCK);
      document.body.style.top = '-' + lastY + 'px';
    }

    function unlock() {
      document.body.classList.remove(SCROLL_LOCK);
      document.body.style.top = '';
      window.scrollTo(0, lastY);
    }

    function open() {
      root.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      tab.setAttribute('aria-expanded', 'true');
      lock();
      try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
      document.addEventListener('keydown', onKeydown, true);
    }

    function close() {
      root.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      tab.setAttribute('aria-expanded', 'false');
      unlock();
      document.removeEventListener('keydown', onKeydown, true);
      try { tab.focus({ preventScroll: true }); } catch (e) {}
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    tab.addEventListener('click', open);
    Array.prototype.forEach.call(root.querySelectorAll('[data-mdj-close]'), function (el) {
      el.addEventListener('click', close);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mdj-reviews-tab]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
